import React from 'react';
import { IconCheck, IconX } from '@tabler/icons-react';
import PropTypes from 'prop-types';

const PasswordRequirements = ({ password, className = '' }) => {
  // Validation functions matching Yup schema requirements
  const hasMinLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const requirements = [
    { text: 'Minimum 8 characters', met: hasMinLength },
    { text: 'At least one uppercase letter (A–Z)', met: hasUppercase },
    { text: 'At least one lowercase letter (a–z)', met: hasLowercase },
    { text: 'At least one number (0–9)', met: hasNumber },
    { text: 'At least one special character (!@#$%^&*)', met: hasSpecialChar },
  ];

  return (
    <div className={`password-requirements ${className}`}>
      <h4 className="text-sm font-semibold text-gray-700 mb-2">
        Password Requirements
      </h4>
      <ul className="space-y-1">
        {requirements.map((req, index) => (
          <li key={index} className="flex items-center gap-2 text-sm">
            {req.met ? (
              <IconCheck size={16} className="text-green-600 flex-shrink-0" />
            ) : (
              <IconX size={16} className="text-red-500 flex-shrink-0" />
            )}
            <span className={req.met ? 'text-green-700' : 'text-gray-600'}>
              {req.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default PasswordRequirements;
